import moment from 'moment-timezone'
import { useEffect, useState } from 'react'

// O writer (serverless) grava date_contribute em `dayjs(...).tz(live.utc).format('YYYY-MM-DD')`.
// "Hoje" precisa ser computado no MESMO UTC do host — senão a query pega ontem.
export function computeHostDay(
  liveUtc: string | undefined | null,
  fallback: string,
): string {
  if (!liveUtc) return fallback
  try {
    if (moment.tz.zone(liveUtc)) return moment.tz(liveUtc).format('YYYY-MM-DD')
    const byOffset = moment().utcOffset(liveUtc)
    if (byOffset.isValid()) return byOffset.format('YYYY-MM-DD')
  } catch {}
  return fallback
}

// Dia atual no fuso do host, re-computado quando a meia-noite do host vira
// (live que atravessa o dia). O valor entra nas queryKeys do react-query, então
// a troca de dia refaz as queries sozinha e o jogo reinicia na primeira bomba.
export function useHostDay(liveUtc?: string | null): string {
  const [day, setDay] = useState(() =>
    computeHostDay(liveUtc, moment().format('YYYY-MM-DD')),
  )

  useEffect(() => {
    const update = () =>
      setDay(computeHostDay(liveUtc, moment().format('YYYY-MM-DD')))

    update()
    const id = setInterval(update, 30_000)
    return () => clearInterval(id)
  }, [liveUtc])

  return day
}
